import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import logo from "../assets/logo.png";
import "./Navbar.css";

function Navbar() {
  const [open, setOpen] = useState(false);

  const closeMenu = () => {
    setOpen(false);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  return (
    <nav className="navbar">
      <Link to="/" className="brand" onClick={closeMenu}>
        <img src={logo} alt="Solar Wave Technology" className="logo" />
        <div className="brand-text">
          <span>Solar Wave</span>
          <small>Technology</small>
        </div>
      </Link>

      <div className={`links ${open ? "active" : ""}`}>
        <NavLink to="/" onClick={closeMenu}>
          Home
        </NavLink>
        <NavLink to="/products" onClick={closeMenu}>
          Products
        </NavLink>
        <NavLink to="/about" onClick={closeMenu}>
          About
        </NavLink>
        <NavLink to="/contact" onClick={closeMenu}>
          Contact
        </NavLink>
        <NavLink to="/reviews" onClick={closeMenu}>
  Reviews
</NavLink>

        <Link to="/contact" className="nav-cta" onClick={closeMenu}>
          Free Quote
        </Link>
      </div>

      <button
        className={`menu ${open ? "active" : ""}`}
        onClick={() => setOpen(!open)}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </nav>
  );
}

export default Navbar;